import type { ReactNode } from 'react';
import { PublicOrgMemberPage } from '@/components/layout/PublicOrgMemberPage';

interface PublicOrgConsumerPortalPageProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}

/** Lesson/guardian member pages in the unified public org shell (banner hero + content area). */
export function PublicOrgConsumerPortalPage({
  title,
  description,
  actions,
  children,
}: PublicOrgConsumerPortalPageProps) {
  return (
    <PublicOrgMemberPage title={title} description={description} actions={actions}>
      {children}
    </PublicOrgMemberPage>
  );
}
